import { Alert, Button, Space } from "antd";
import { LinkOutlined, KeyOutlined } from "@ant-design/icons";
import { useLocale } from "../contexts/LocaleContext";

export default function TokenPrompt() {
  const { t } = useLocale();

  return (
    <Alert
      message={t.tokenPrompt.title}
      description={
        <div>
          <p style={{ marginBottom: 12 }}>{t.tokenPrompt.description}</p>
          <Space>
            <Button
              type="primary"
              icon={<KeyOutlined />}
              href="https://jsonbin.io/app/app/api-keys"
              target="_blank"
              rel="noopener noreferrer"
            >
              {t.tokenPrompt.getToken}
            </Button>
            <Button
              icon={<LinkOutlined />}
              href="https://jsonbin.io"
              target="_blank"
              rel="noopener noreferrer"
            >
              {t.tokenPrompt.visitSite}
            </Button>
          </Space>
        </div>
      }
      type="info"
      showIcon
      style={{ marginBottom: 24 }}
    />
  );
}
